import React from "react";

const LoadingSuccessErrorAlert = ({ loading, handle_reload, hide_error }) => {
  return (
    <div className="ps-4 pe-5 bg-white">
      {loading.status === "Saving" && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="fas fa-circle-notch fa-spin" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
      {loading.status === "Loading" && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="fas fa-circle-notch fa-spin" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
      {loading.status === "Error" && !hide_error && (
        <div className="alert alert-danger bg-white small p-2" role="alert">
          <span className="fas fa-exclamation-triangle" />
          &nbsp;
          <strong>
            {loading.message} &nbsp;
            {/* <button
              className="btn btn-info bg-white btn-sm small p-0"
              onClick={handle_reload}
            >
              Retry
            </button> */}
          </strong>
        </div>
      )}
      {loading.status === "Success" && loading.message !== undefined && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="far fa-check-circle" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
    </div>
  );
};
export default LoadingSuccessErrorAlert;
